import React from "react";
import Level from "./Level";


const Levels = (props) => {

	return (
		<div className={'levels'}>
			{props.data.map((level, index) => <Level key={index} index={index} data={level} status={props.status} statusChange={props.statusChange} appName={props.appName}/>)}
		</div>
	);
};

export default Levels;